export const sessIdLength = 32;
